"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCarSideSolid16 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h16v16H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "m11.446 6.435.258.047.193.042.226.06c.678.197 1.62.627 1.62 1.518V9.8H12.74a1.713 1.713 0 0 1-3.426 0H6.614a1.713 1.713 0 0 1-3.426 0l.001-.051-.087-.06c-.563-.41-.845-.873-.845-1.39 0-.846.142-1.715.354-2.443l-.294-1.002.838-.13.444-.064.274-.034.822-.078.337-.025.38-.021c1.73-.077 4.481.08 6.034 1.933ZM4.9 9.087a.713.713 0 1 0 0 1.426.713.713 0 0 0 0-1.426Zm6.127 0a.713.713 0 1 0 0 1.426.713.713 0 0 0 0-1.426Z", fill: "currentColor" })] })) }))); };
exports.default = SvgCarSideSolid16;
